"use client";

import { Url } from "next/dist/shared/lib/router/router";
import { Link } from "@/i18n/routing";
import { usePathname } from "next/navigation";
import { ElementType, useState } from "react";
import { useLocale } from "next-intl";
import { RiArrowDropDownLine } from "react-icons/ri";

type Props = {
  label: string;
  url: Url;
  classN?: string;
  Icon: ElementType;
  hasDropDown?: boolean;
  dropDown?: ElementType;
  anchor?: string;
  anchor2?: string;
  anchor3?: string;
  subLabel?: string;
  subLabel2?: string;
  subLabel3?: string;
  isMobile?: boolean;
  onClick?: () => void;
  setHasDropDown?: () => void;
};

export function NavlinkHome({ label, url, Icon, classN }: Props) {
  const pathName = usePathname();

  const currentLocale = useLocale();

  console.log(pathName);
  // ${url}${currentLocale}

  if (pathName === `/${currentLocale}${url}`)
    return (
      <Link
        onClick={() => console.log(`/${currentLocale}${url} --- ${pathName}`)}
        href={url}
        className={`flex-[1] flex px-2 py-2 gap-2 items-cente justify-start lg:text-center lg:justify-center relative bg-white link_active text-white  lg:text-[#009900] font-bold   
             ${classN}  transition-all duration-300 cursor-pointer  `}
      >
        <Icon
          className={` text-[#009900]
           text-xl `}
        />

        <p
          className={` text-[#009900]
            text-lg `}
        >
          {label}
        </p>
      </Link>
    );

  return (
    <Link
      onClick={() => console.log(`/${currentLocale}${url} --- ${pathName}`)}
      href={url}
      className={`flex-[1] flex px-2 py-2 gap-2 lg:text-center link_no_active relative lg:justify-center link_a  group  items-center  
      } ${classN}  transition-all duration-300 cursor-pointer  `}
    >
      <Icon
        className={` text-white lg:text-[#111]
           text-xl group-hover:text-[#009900] `}
      />

      <p
        className={` text-white lg:text-[#111] group-hover:text-[#009900]
            text-lg `}
      >
        {label}
      </p>
    </Link>
  );
}

export function NavLinkPages({
  label,
  url,
  Icon,
  classN,
  hasDropDown,
  dropDown,
}: Props) {
  const pathName = usePathname();
  // const [showDrop, setShowDrop] = useState(false);
  const currentLocale = useLocale();

  // console.log(pathName);

  if (pathName === `/${currentLocale}${url}/`)
    return (
      <Link
        // onClick={() => console.log(`/${currentLocale}${url}/ --- ${pathName}`)}
        href={url}
        className={`flex-[1]  relative flex px-2 py-2 gap-2 lg:text-center lg:justify-center link_active   items-center ${
          pathName === `/${currentLocale}${url}/`
            ? "   bg-white text-[#009900] font-bold  relative active_link"
            : "border-y-2 border-[#009900]"
        } ${classN}  transition-all duration-300 cursor-pointer ${
          hasDropDown ? " hover:text-[#009900] " : ""
        }  rounded-sm group `}
      >
        <Icon
          className={` text-[#009900]
           text-xl `}
        />
        <p
          className={` text-[#009900]
            text-lg `}
        >
          {label}
        </p>
        {/* has dropDown */}
        {hasDropDown && (
          <div className="absolute top-1.5 right-2 ">
            <RiArrowDropDownLine
              className={`text-3xl ${
                pathName === `/${currentLocale}${url}`
                  ? " text-[#009900] "
                  : "text-[#111] "
              } transition-all duration-300 group-hover:rotate-180 `}
            />
          </div>
        )}
        {hasDropDown && (
          <div
            className={`flex flex-col transition-all rounded-sm overflow-hidden duration-300 opacity-0 -translate-y-5 absolute top-11 left-0 group-hover:opacity-100 group-hover:translate-y-0 hover:border-b border-[#009900]/30 `}
          >
            <div className=" border-b  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] ">
              <a href={"#"}>Mission & Vision & But</a>
            </div>
            <div className="   w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900]  ">
              <a href={"#"}>Valeur & Mandat </a>
            </div>
          </div>
        )}
      </Link>
    );

  return (
    <Link
      onClick={() => console.log(`/${currentLocale}${url}/ --- ${pathName}`)}
      href={url}
      className={`flex-[1]  relative flex px-2 py-2 link_a group gap-2 lg:items-center lg:text-center justify-center ${
        pathName === `/${currentLocale}${url}/`
          ? "   bg-white text-[#009900] font-bold  relative active_link"
          : ""
      } ${classN}  transition-all duration-300 cursor-pointer ${
        hasDropDown
          ? "hover:bg-white/55 hover:text-[#009900] "
          : "hover:bg-white/35"
      }  rounded-sm group `}
    >
      {pathName === `/${currentLocale}${url}` ? (
        <Icon
          className={` text-[#009900]
           text-xl `}
        />
      ) : (
        <Icon
          className={` text-white lg:text-[#111]
           text-xl group-hover:text-[#009900]`}
        />
      )}

      {pathName === `/${currentLocale}${url}` ? (
        <p
          className={` text-[#009900]
            text-lg `}
        >
          {label}
        </p>
      ) : (
        <p
          className={`text-white  lg:text-[#111]
           text-lg group-hover:text-[#009900] `}
        >
          {label}
        </p>
      )}

      {/* has dropDown */}
      {hasDropDown && (
        <div className="absolute top-1.5 right-2 ">
          <RiArrowDropDownLine
            className={`text-3xl ${
              pathName === `/${currentLocale}${url}`
                ? " text-[#009900] "
                : "text-white "
            } transition-all duration-300 group-hover:rotate-180 `}
          />
        </div>
      )}

      {hasDropDown && (
        <div
          className={`flex flex-col transition-all rounded-sm overflow-hidden duration-300 opacity-0 -translate-y-5 absolute top-11 left-0 group-hover:opacity-100 group-hover:translate-y-0 hover:border-b border-[#009900]/30 `}
        >
          <div className=" border-b  w-full font-normal text-white p-2  transition-all duration-200 hover:bg-white hover:text-[#009900] ">
            <a href={"#"}>Mission & Vision & But</a>
          </div>
          <div className="   w-full font-normal text-white p-2 transition-all duration-200 hover:bg-white hover:text-[#009900]  ">
            <a href={"#"}>Valeur & Mandat </a>
          </div>
        </div>
      )}
    </Link>
  );
}

export function NavLinkDropPages({
  label,
  url,
  Icon,
  classN,
  hasDropDown,
  anchor,
  anchor2,
  anchor3,
  subLabel,
  subLabel2,
  subLabel3,
  isMobile,
}: Props) {
  const pathName = usePathname();

  const currentLocale = useLocale();

  if (pathName === `/${currentLocale}${url}/`)
    return (
      <div
        className={`flex-[1]  flex px-2 py-2 gap-2 items-center lg:text-center lg:justify-center  link_active  bg-white text-[#009900] font-bold  relative active_link
          ${classN}  transition-all duration-300 cursor-pointer ${
            hasDropDown
              ? "hover:bg-white/55 hover:text-[#009900] "
              : "hover:bg-white/35"
          }   rounded-sm group `}
      >
        <Link
          onClick={() =>
            console.log(`/${currentLocale}${url}/ --- ${pathName}`)
          }
          href={url}
          className="flex items-center gap-2"
        >
          <Icon
            className={` text-[#009900]
           text-xl `}
          />

          <p
            className={` text-[#009900]
            md:text-sm lg:text-lg `}
          >
            {label}
          </p>

          {/* has dropDown */}
          {hasDropDown && (
            <div className="absolute top-1.5 -right-2 ">
              <RiArrowDropDownLine
                className={`text-3xl ${
                  pathName === `/${currentLocale}${url}/`
                    ? " text-[#009900] "
                    : "text-white "
                } transition-all duration-300 group-hover:rotate-180 `}
              />
            </div>
          )}
        </Link>
        {hasDropDown && (
          <div
            className={`flex flex-col pointer-events-none ${
              isMobile ? "bg-white" : ""
            } transition-all w-full rounded-sm overflow-hidden duration-300 opacity-0 -translate-y-5 absolute top-11 left-0 group-hover:opacity-100 group-hover:pointer-events-auto group-hover:translate-y-0 hover:border-b border-[#009900]/30 `}
          >
            <Link
              href={anchor!}
              className="w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900]"
            >
              {subLabel}
            </Link>

            {anchor2 && (
              <Link
                href={anchor2!}
                className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
              >
                {subLabel2}
              </Link>
            )}

            {anchor3 && (
              <Link
                href={anchor3!}
                className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
              >
                {subLabel3}
              </Link>
            )}
          </div>
        )}
      </div>
    );

  return (
    <div
      className={`flex-[1] link_a relative flex px-2 py-2 gap-2 lg:text-center lg:justify-center   ${classN}  transition-all duration-300 cursor-pointer ${
        hasDropDown
          ? "hover:bg-white/55 hover:text-[#009900] "
          : "hover:bg-white/35"
      }  rounded-sm group `}
    >
      <Link
        onClick={() => console.log(`/${currentLocale}${url}/ --- ${pathName}`)}
        href={url}
        className="flex items-center gap-2"
      >
        <Icon
          className={` text-white lg:text-[#111]
           text-2xl group-hover:text-[#009900]`}
        />

        <p
          className={` text-white lg:text-[#111]
            md:text-sm lg:text-lg group-hover:text-[#009900]`}
        >
          {label}
        </p>

        {/* has dropDown */}
        {hasDropDown && (
          <div className="absolute top-1.5 md:-right-2 lg:right-0 ">
            <RiArrowDropDownLine
              className={`text-3xl ${
                pathName === `/${currentLocale}${url}`
                  ? " text-[#009900] "
                  : "text-[#111] "
              } transition-all duration-300 group-hover:rotate-180 `}
            />
          </div>
        )}
      </Link>
      {hasDropDown && (
        <div
          className={`flex flex-col pointer-events-none transition-all w-full rounded-sm overflow-hidden duration-300 opacity-0 -translate-y-5 absolute top-11 left-0 group-hover:opacity-100 group-hover:pointer-events-auto group-hover:translate-y-0 hover:border-b border-[#009900]/30 `}
        >
          <Link
            href={anchor!}
            className="w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900]"
          >
            {subLabel}
          </Link>

          {anchor2 && (
            <Link
              href={anchor2!}
              className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
            >
              {subLabel2}
            </Link>
          )}

          {anchor3 && (
            <Link
              href={anchor3!}
              className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
            >
              {subLabel3}
            </Link>
          )}
        </div>
      )}
    </div>
  );
}

export function NavLinkDropPagesMobile({
  label,
  url,
  Icon,
  classN,

  anchor,
  anchor2,
  anchor3,
  subLabel,
  subLabel2,
  subLabel3,
  isMobile,
}: Props) {
  const pathName = usePathname();

  const currentLocale = useLocale();
  // /${currentLocale}${url}/

  const [hasDropDown, setHasDropDown] = useState(false);

  return (
    <div
      className={`flex-[1]  relative flex flex-col px-2 py-2 gap-2 lg:items-center lg:text-center justify-center  border-y-2 border-[#009900] ${classN}  transition-all duration-300 cursor-pointer rounded-sm group `}
    >
      <Link
        onMouseEnter={() => setHasDropDown(!hasDropDown)}
        onClick={() => {
          console.log(`/${currentLocale}${url}/ --- ${pathName}`);
        }}
        href={url}
        className="flex items-center gap-2 w-full "
      >
        <Icon
          className={` text-white
           text-2xl hover:text-[#009900]`}
        />
        <p
          className={` text-white
            md:text-sm lg:text-lg `}
        >
          {label}
        </p>
        {/* has dropDown */}
        <div className="absolute top-1.5 right-0 ">
          <RiArrowDropDownLine
            className={`text-3xl ${
              pathName === `/${currentLocale}${url}`
                ? " text-[#009900] "
                : "text-white "
            } transition-all duration-300 ${
              hasDropDown ? "rotate-180" : " rotate-0 "
            } `}
          />
        </div>
      </Link>
      {hasDropDown && (
        <div
          className={`flex flex-col  transition-all w-full rounded-sm overflow-hidden duration-300    `}
        >
          <Link
            href={anchor!}
            className="w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900]"
          >
            {subLabel}
          </Link>

          {anchor2 && (
            <Link
              href={anchor2!}
              className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
            >
              {subLabel2}
            </Link>
          )}

          {anchor3 && (
            <Link
              href={anchor3!}
              className="border-t  w-full font-normal text-white p-2 bg-[#009900] transition-all duration-200 hover:bg-white hover:text-[#009900] "
            >
              {subLabel3}
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
